<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="pa-4">
        <div class="grid_half ma-3 ml-xl-8 ml-lg-8 ml-md-8">
          <div class="grid_sub_half">
            <div class="padding_header"><b>เลขที่ใบวางบิล : {{ header_data.code }}</b></div>
            <!-- รอตรวจสอบการชำระเงิน -->
            <div v-if="header_data.status === 1" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #fdac39">รอลูกค้าชำระเงิน</b></div>
            <div v-else-if="header_data.status === 3" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: red">หลักฐานไม่ถูกต้อง</b></div>
            <div v-else-if="header_data.status === 2" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #8cc63e">ชำระเงินสำเร็จ</b></div>
            <div v-else-if="header_data.status === 4" class="padding_header" style="color: black"><b>สถานะ :</b> <b
                style="color: #3988fd">รอตรวจสอบสลิป</b></div>
          </div>
        </div>
        <div class="grid_half ma-md-3 ma-lg-3 ma-xl-3">
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class=""><b>ข้อมูลลูกหนี้</b></div>
            <div class="mt-2">
              <div class="ml-1 mr-3">ชื่อ : {{ header_data.name }}</div>
            </div>
            <div class="mt-2">
              <div class="ml-1 mr-3">เบอร์โทร : {{ header_data.telephone }}</div>
            </div>
          </v-card>
          <v-card elevation="6" class="pa-4 ma-md-3 ma-lg-3 ma-xl-3 mt-3 mb-sm-4 rounded_card">
            <div class="grid_img">
              <div>
                <div class=""><b>ชำระหนี้</b></div>
                <div class="grid_flex mt-2" v-if="header_data.status !== 2">
                  <div class="ml-1 mr-3">วันที่ครบกำหนดชำระ : </div>
                  <div class="ml-1 mr-3">{{ header_data.due_date }}</div>
                </div>
                <div class="grid_flex mt-2">
                  <div class="ml-1 mr-3">ยอดเงินเรียกเก็บ : </div>
                  <div class="ml-1 mr-3">{{ header_data.total_price }} บาท</div>
                </div>
                <div v-if="header_data.status === 2" class="ml-1 mt-2" style="color: #86bc3a;">
                  ผ่านการตรวจสอบการชำระเงินแล้ว</div>
                <div v-if="header_data.status === 2" class="grid_flex mt-2" style="color: #86bc3a;">
                  <div class="ml-1 mr-3">ผู้ตรวจสอบ : </div>
                  <div class="ml-1 mr-3">{{ header_data.user_confirm_name }} {{ header_data.updated_at }}</div>
                </div>
                <div v-if="header_data.status === 3" class="ml-1 mt-2" style="color: red;">หลักฐานการโอนเงินไม่ถูกต้อง
                </div>
                <div v-if="header_data.status === 3" class="grid_flex mt-2" style="color: red;">
                  <div class="ml-1 mr-3">ผู้ตรวจสอบ : </div>
                  <div class="ml-1 mr-3">{{ header_data.user_cancel_name }} {{ header_data.updated_at }}</div>
                </div>
                <!-- <div class="mt-2 display_pc" v-if="header_data.status === 1"> -->
                <div class="mt-2 display_pc"
                  v-if="header_data.status === 4 && data_list.find(o => (o.status == 1 || o.status == 3) && o.type_pay == 1) == null">
                  <v-btn elevation="5" @click="image_modal = true"
                    class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
                </div>
                <div class="mt-2 display_pc"
                  v-if="header_data.status === 3 && data_list.find(o => (o.status == 1 || o.status == 3) && o.type_pay == 1) == null">
                  <v-btn elevation="5" @click="image_addon = true"
                    class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
                </div>
              </div>
              <div class="mx-auto">
                <v-img class="rounded cursor_img" height="160" width="160" max-width="160" @click="show_img"
                  v-if="header_data.slip_1 !== ''" :lazy-src="picture_holder" :src="header_data.slip_1"></v-img>
                <v-img class="rounded" height="160" width="160" max-width="160" v-else :lazy-src="picture_holder"
                  :src="picture_holder"></v-img>
              </div>
              <!-- <div class="mt-2 display_mobile" v-if="header_data.status === 1"> -->
              <div class="mt-2 display_mobile" v-if="header_data.status === 4">
                <v-btn elevation="5" @click="image_modal = true"
                  class="mobile_btn pa-6 grad-warning-bg white--text rounded-pill">ยืนยันการตรวจสอบ</v-btn>
              </div>
              <div class="mt-2 display_mobile" v-if="header_data.status === 3">
                <v-btn elevation="5" @click="image_addon = true"
                  class="mobile_btn pa-6 ma-1 grad-warning-bg white--text rounded-pill">อัพโหลดหลักฐานเพิ่มเติม</v-btn>
              </div>
            </div>
          </v-card>
        </div>
        <div class="content_list">
          <v-card elevation="6" class="rounded-lg ma-md-5 ma-lg-5 ma-xl-5 mt-3">
            <div class="pa-5">
              <div class="mt-4 mb-4"><b>รายการ</b></div>
              <template>
                <v-expansion-panels v-model="panel">

                  <v-expansion-panel class="mb-3 pt-5 pb-5 rounded-xl" v-for="(item, index) in data_list" :key="index">
                    <v-expansion-panel-header>
                      <div class="d-flex justify-space-between font_size_grid">
                        <div>เลขที่ : {{ item.order_code }} </div>
                        <div class="">วันที่สั่งซื้อ {{ item.created_at }}</div>
                        <div class="">ยอดการสั่งซื้อ : {{ format_price(item.total) }} บาท</div>
                        <div class="font_size_grid">
                          <v-chip v-if="item.status === 0" color="red" active class="font_mobile" outlined
                            dark>ยังไม่ได้ชำระ</v-chip>
                          <v-chip v-if="item.status === 1" color="orange" class="font_mobile" outlined
                            dark>ชำระแล้วรอตรวจสอบ </v-chip>
                          <v-chip v-if="item.status === 2" color="green" class="font_mobile" outlined dark>ชำระเสร็จสิ้น
                          </v-chip>
                          <v-chip v-if="item.status === 3" color="red" class="font_mobile" outlined
                            dark>สลิปไม่ถูกต้องชำระใหม่ </v-chip>
                          <v-chip v-if="item.type_pay == 1 && item.status != 0" color="green" class="font_mobile ml-2"
                            outlined dark>จ่ายเฉพาะบิล </v-chip>
                          <v-chip v-if="item.type_pay == 0 && item.status != 0" color="green" class="font_mobile ml-2" outlined dark>จ่ายรวม
                          </v-chip>
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="ma-2">
                        <div class="font_size_grid mb-1">
                          <div>ผู้รับ : {{ item.name }} ({{ item.telephone }})</div>
                        </div>
                        <div class="font_size_grid mb-1">
                          <div>ที่อยู่ : {{ (item.delivery_type === 1) ? ' รับที่ร้านฟาร์มาแคร์ พลัส (สำนักงานใหญ่)' : item.address }}</div>
                        </div>
                        <div class="mt-3">
                          <v-divider />
                          <v-data-table class="color_table_1" :headers="headers" :items="item.list"
                            :footer-props="footer_Props" mobile-breakpoint="0">
                            <template v-slot:item="dataDetail">
                              <tr>
                                <td class="pa-3">
                                  <div class="image_grid">
                                    <div class="mx-auto">
                                      <v-img height="64" width="64" max-width="64" v-if="dataDetail.item.picture !== ''"
                                        :lazy-src="picture_product" :src="dataDetail.item.picture"
                                        class="preview mx-auto"></v-img>
                                      <v-img height="64" width="64" max-width="64" v-else :lazy-src="picture_product"
                                        :src="picture_product" class="preview mx-auto"></v-img>
                                    </div>
                                    <div class="pa-2 pt-4 font_mobile">{{ dataDetail.item.name }}</div>
                                  </div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_price(dataDetail.item.cost) }}</div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_number(dataDetail.item.quantity) }} {{
                                    dataDetail.item.unit_name }}</div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_price(dataDetail.item.total) }}</div>
                                </td>
                              </tr>
                            </template>
                            <template v-slot:body.append>
                              <tr>
                                <td colspan="2" class="text-right mr-3"><b>ค่าจัดส่ง</b></td>
                                <td></td>
                                <td class="text-center"><b>{{ format_number(item.delivery_price) }}</b></td>
                              </tr>
                              <tr>
                                <td colspan="2" class="text-right mr-3"><b>รวม</b></td>
                                <td></td>
                                <td class="text-center"><b>{{ format_price(item.total) }}</b></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                        <div class="mt-3 text-center">
                          <v-btn v-if="item.status === 1 && item.type_pay === 1" small height="42"
                            @click="sub_image_data(item.slip, item.order_wholesale_credit_list_id, item.total)"
                            class="grad-warning-bg  white--text ml-1 mb-1" title="ยืนยันการตรวจสอบ">
                            <v-icon>mdi-check-bold</v-icon> ยืนยันการตรวจสอบ
                          </v-btn>
                          <v-btn v-if="item.status === 3 && item.type_pay === 1" small height="42"
                            @click="sub_image_addon(item.slip, item.order_wholesale_credit_list_id, item.total)"
                            class="grad-warning-bg  white--text ml-1 mb-1" title="อัพโหลดหลักฐานเพิ่มเติม">
                            <v-icon>mdi-cloud-upload</v-icon> อัพโหลดหลักฐานเพิ่มเติม
                          </v-btn>
                          <v-btn v-if="item.status === 2 && item.type_pay === 1" small height="42"
                            @click="sub_image_addon_detail(item.slip, item.order_wholesale_credit_list_id, item.total)"
                            class="grad-success-bg  white--text ml-1 mb-1" title="หลักฐานการชำระเงิน">
                            <v-icon>mdi-image-search</v-icon> หลักฐานการชำระเงิน
                          </v-btn>
                          <v-btn small height="42" class="grad-main-bg white--text ml-1 mb-1" title="พิมพ์ใบเสร็จ"
                            @click="print_send_order(item.order_code)">
                            <v-icon>mdi-printer</v-icon> พิมพ์
                          </v-btn>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>

                  <v-expansion-panel class="mb-3 pt-5 pb-5 rounded-xl"
                    v-for="(item_cash_back, index_cash_back) in cash_back" :key="index_cash_back">
                    <v-expansion-panel-header>
                      <div class="grid_three font_size_grid">
                        <div>เลขที่ : {{ item_cash_back.order_code }} <span style="color:red">(ลดหนี้)</span></div>
                        <div class="sub_grid_three">
                          <div>วันที่สั่งซื้อ {{ item_cash_back.start_date }}</div>
                          <div>ยอดการสั่งซื้อ : {{ format_price(item_cash_back.total) }} บาท</div>
                        </div>
                      </div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <div class="ma-2">
                        <div class="font_size_grid mb-1">
                          <div>ผู้รับ : {{ item_cash_back.name }} ({{ item_cash_back.telephone }})</div>
                        </div>
                        <div class="font_size_grid mb-1">
                          <div>ที่อยู่ : {{ (item_cash_back.delivery_type == 1) ? ' รับที่ร้านฟาร์มาแคร์ พลัส (สำนักงานใหญ่)' : item_cash_back.address }}</div>
                        </div>
                        <div class="mt-3">
                          <v-data-table class="color_table_1" :headers="headers" :items="data_list_cash_back[0].list"
                            :footer-props="footer_Props" mobile-breakpoint="0">
                            <template v-slot:item="dataDetailCashback">
                              <tr>
                                <td class="pa-3">
                                  <div class="image_grid">
                                    <div class="mx-auto">
                                      <v-img height="64" width="64" max-width="64"
                                        v-if="dataDetailCashback.item.picture !== ''" :lazy-src="picture_product"
                                        :src="dataDetailCashback.item.picture" class="preview mx-auto"></v-img>
                                      <v-img height="64" width="64" max-width="64" v-else :lazy-src="picture_product"
                                        :src="picture_product" class="preview mx-auto"></v-img>
                                    </div>
                                    <div class="pa-2 pt-4 font_mobile">{{ dataDetailCashback.item.name }}</div>
                                  </div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_price(dataDetailCashback.item.cost) }}
                                  </div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_number(dataDetailCashback.item.quantity)
                                  }} {{ dataDetailCashback.item.unit_name }}</div>
                                </td>
                                <td>
                                  <div class="font_mobile text-center">{{ format_price(dataDetailCashback.item.total) }}
                                  </div>
                                </td>
                              </tr>
                            </template>
                            <template v-slot:body.append>
                              <tr>
                                <td colspan="2" class="text-right mr-3"><b>ค่าจัดส่ง</b></td>
                                <td></td>
                                <td class="text-center"><b>0</b></td>
                              </tr>
                              <tr>
                                <td colspan="2" class="text-right mr-3"><b>รวม</b></td>
                                <td></td>
                                <td class="text-center"><b>{{ item_cash_back.total }}</b></td>
                              </tr>
                            </template>
                          </v-data-table>
                        </div>
                      </div>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </template>
            </div>
          </v-card>
        </div>
        <!-- Process Modal -->
        <v-dialog v-model="image_modal" max-width="600">
          <v-card>
            <v-form ref="image">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : {{ header_data.total_price }} บาท </div>
                </div>
                <div class="pa-6">
                  <v-img class="mx-auto rounded" v-if="header_data.slip_1 !== ''" width="300" max-width="300"
                    :lazy-src="picture_holder" :src="header_data.slip_1"></v-img>
                  <v-img class="mx-auto rounded" v-else width="300" max-width="300"
                    :lazy-src="picture_holder" :src="picture_holder"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="confirm_detail()"
                    class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="in_correct"
                    class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- Process Modal -->
        <v-dialog v-model="sub_image_modal" max-width="600">
          <v-card>
            <v-form ref="image">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  <b>ตรวจสอบการชำระเงิน</b>
                </v-card-title>
                <v-btn icon class="ma-4" @click="sub_image_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="">
                  <div class="">ยอดชำระ : {{ total }} บาท </div>
                </div>
                <div class="pa-6">
                  <v-img class="mx-auto rounded"  v-if="slip !== ''" width="300" max-width="300"
                    :lazy-src="picture_holder" :src="slip"></v-img>
                  <v-img class="mx-auto rounded"  v-else width="300" max-width="300"
                    :lazy-src="picture_holder" :src="picture_holder"></v-img>
                </div>
                <div class="mb-5">
                  <div class="">การชำระเงินของลูกค้า มีการโอนเงินที่ถูกต้องเรียบร้อยดีหรือไม่ ?</div>
                </div>
                <div class="text-right">
                  <v-btn elevation="5" @click="sub_confirm_detail()"
                    class="pa-6 grad-success-bg white--text rounded-pill mr-2 ml-2">การโอนเงินถูกต้อง</v-btn>
                  <v-btn elevation="5" @click="sub_in_correct()"
                    class="pa-6 grad-danger-bg white--text rounded-pill mr-2 ml-2">ไม่ถูกต้อง</v-btn>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- Add Picture -->
        <v-dialog v-model="image_addon" max-width="520">
          <v-card>
            <v-form ref="image" @submit.prevent="upload_addon">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  อัพโหลดหลักฐานการโอนเงินเพิ่มเติม
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_addon = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-6">
                  <div class="ml-4">
                    <v-img height="300" max-width="300" v-if="imagePreviewURL == null" :lazy-src="picture_holder"
                      :src="picture_holder" class="preview mx-auto"></v-img>
                    <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :src="imagePreviewURL"
                      class="preview mx-auto"></v-img>
                  </div>
                  <v-file-input prepend-icon="mdi-image" color="#86bc3a" accept="image/*" label="อัพโหลด"
                    :rules="[v => !!v || 'กรุณาอัพโหลดไฟล์']" v-model="addon_file" @change="onFileChange"></v-file-input>
                  <div>การอัพโหลดหลักฐานเพิ่มเติมจาก Admin จะทำการยืนยันหลักฐาน อัตโนมัติ</div>
                  <div class="mt-6">
                    <v-btn x-large v-if="imagePreviewURL == null" class="rounded-pill white--text grad-grey-bg btn_size"
                      disabled>อัพโหลด</v-btn>
                    <v-btn type="submit" x-large v-if="imagePreviewURL !== null"
                      class="rounded-pill white--text grad-success-bg btn_size">อัพโหลด</v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <!-- Add Picture -->
        <v-dialog v-model="image_addon_dialog" max-width="520">
          <v-card>
            <v-form ref="image" @submit.prevent="upload_addon_sub">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  อัพโหลดหลักฐานการโอนเงินเพิ่มเติม
                </v-card-title>
                <v-btn icon class="ma-4" @click="image_addon_dialog = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-6">
                  <div class="ml-4">
                    <v-img height="300" max-width="300" v-if="imagePreviewURL == null" :lazy-src="picture_holder"
                      :src="picture_holder" class="preview mx-auto"></v-img>
                    <v-img height="300" max-width="300" v-if="imagePreviewURL !== null" :src="imagePreviewURL"
                      class="preview mx-auto"></v-img>
                  </div>
                  <v-file-input prepend-icon="mdi-image" color="#86bc3a" accept="image/*" label="อัพโหลด"
                    :rules="[v => !!v || 'กรุณาอัพโหลดไฟล์']" v-model="addon_file" @change="onFileChange"></v-file-input>
                  <div>การอัพโหลดหลักฐานเพิ่มเติมจาก Admin จะทำการยืนยันหลักฐาน อัตโนมัติ</div>
                  <div class="mt-6">
                    <v-btn x-large v-if="imagePreviewURL == null" class="rounded-pill white--text grad-grey-bg btn_size"
                      disabled>อัพโหลด</v-btn>
                    <v-btn type="submit" x-large v-if="imagePreviewURL !== null"
                      class="rounded-pill white--text grad-success-bg btn_size">อัพโหลด</v-btn>
                  </div>
                </div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
        <v-dialog v-model="image_addon_detail_dialog" max-width="520">
          <v-card>
            <div class="d-flex justify-space-between">
              <v-card-title>
                หลักฐานการชำระเงิน
              </v-card-title>
              <v-btn icon class="ma-4" @click="image_addon_detail_dialog = false">
                <v-icon color="grey">mdi-close</v-icon>
              </v-btn>
            </div>
            <v-card-text>
              <div class="pa-6">
                <div class="ml-4">
                  <v-img  max-width="300" v-if="imagePreviewURL == null" :lazy-src="picture_holder"
                    :src="picture_holder" class="preview mx-auto"></v-img>
                  <v-img  max-width="300" v-if="imagePreviewURL !== null" :src="imagePreviewURL"
                    class="preview mx-auto"></v-img>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- Show Picture -->
        <v-dialog v-model="preview_modal" max-width="512">
          <v-card>
            <v-form ref="cancel">
              <div class="d-flex justify-space-between">
                <v-card-title>
                  หลักฐานการชำระเงิน
                </v-card-title>
                <v-btn icon class="ma-4" @click="preview_modal = false">
                  <v-icon color="grey">mdi-close</v-icon>
                </v-btn>
              </div>
              <v-card-text>
                <div class="pa-1 mt-2">
                  <v-img max-width="360" v-if="header_data.slip_1 !== null" :lazy-src="picture_holder"
                    :src="header_data.slip_1" class="mx-auto"></v-img>
                  <v-img max-width="360" v-else :lazy-src="picture_holder" :src="picture_holder" class="mx-auto"></v-img>
                </div>
                <div class="pa-1 mt-2" v-if="header_data.slip_2 !== null">
                  <v-img max-width="360" v-if="header_data.slip_2 !== null" :lazy-src="picture_holder"
                    :src="header_data.slip_2" class="mx-auto"></v-img>
                </div>
                <div class="text-center pt-2" style="color: #8cc63e">ผู้อัพโหลด : {{ header_data.user_confirm_name }}
                  {{ header_data.updated_at }}</div>
              </v-card-text>
            </v-form>
          </v-card>
        </v-dialog>
      </div>
      <v-overlay :value="overlay" class="z_index">
        <div class="text-center">
          <v-progress-circular indeterminate size="70" width="7" color="#86bc3a"></v-progress-circular>
          <div>โปรดรอสักครู่ระบบกำลังประมวลผล...</div>
        </div>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import picture_holder from "@/assets/picture.png";
import picture_product from "@/assets/pill.png";
import { formatNumber, formatPrice } from "@/js/handler";
import { HTTP } from "@/axios";
import Swal from "sweetalert2";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Transfer_debtor_detail",
  data() {
    return {
      loading_page: false,
      picture_holder: picture_holder,
      picture_product: picture_product,
      imagePreviewURL: null,
      perPage: -1,
      image_modal: false,
      image_addon: false,
      addon_file: null,
      preview_modal: false,
      overlay: false,
      order_number: '',
      panel: false,
      disabled: false,
      readonly: false,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text': 'รายการต่อหน้า'
      },
      header_data: [],
      headers: [
        {
          text: 'รายการสินค้าส่งคืน',
          value: '',
          fixed: true,
          sortable: false,
          width: '300px',
        },
        {
          text: 'ราคาต่อหน่วย',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
        {
          text: 'จำนวน',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
        {
          text: 'รวม',
          value: '',
          fixed: true,
          align: 'center',
          sortable: false,
          width: '180px',
        },
      ],
      data_list: [],
      data_list_cash_back: [],
      cash_back: [],
      sub_image_modal: null,
      slip: null,
      id: null,
      total: null,
      image_addon_dialog: false,
      image_addon_detail_dialog: false,
    }
  },
  methods: {
    format_number: function (value) {
      return formatNumber(value)
    },
    format_price: function (value) {
      return formatPrice(value)
    },
    sub_image_data(slip, id, total) {
      this.slip = slip
      this.id = id
      this.total = total
      this.sub_image_modal = true
    },
    sub_confirm_detail() {
      this.overlay = true
      this.image_modal = false
      HTTP.get('debtors/approve/list/' + this.id + '?status=2').then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.sub_image_modal = false
          this.get_data()
        }
      })
    },
    sub_in_correct() {
      this.overlay = true
      this.image_modal = false
      HTTP.get('debtors/approve/list/' + this.id + '?status=3').then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.sub_image_modal = false
          this.get_data()
        }
      })
    },
    sub_image_addon(slip, id, total) {
      this.slip = slip
      this.id = id
      this.total = total
      this.image_addon_dialog = true
    },
    sub_image_addon_detail(slip, id, total) {
      this.imagePreviewURL = slip
      this.id = id
      this.total = total
      this.image_addon_detail_dialog = true
    },
    onFileChange(payload) {
      if (payload !== null && payload !== undefined) {
        const file = payload
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file_ext = file.name;
        let ext = file_ext.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.addon_file = null
          })
        } else {
          if (file) {
            this.imagePreviewURL = URL.createObjectURL(file)
            URL.revokeObjectURL(file)
          } else {
            this.imagePreviewURL = null
            this.addon_file = null
          }
        }
      } else {
        this.imagePreviewURL = null
        this.addon_file = null
      }
    },
    get_data() {
      const id = this.$route.params.id
      this.loading_page = true
      HTTP.get('debtors/transfer_debtor_detail/' + id)
        .then((res) => {
          if (res.data.success === true) {
            this.loading_page = false
            this.cash_back = res.data.object.cash_back
            this.header_data = res.data.object.debtor
            this.data_list = res.data.object.orders
            this.data_list_cash_back = res.data.object.orders
          }
        })
    },
    show_img() {
      this.preview_modal = true
    },
    upload_addon() {
      this.overlay = true
      this.image_addon = false
      if (this.$refs.image.validate()) {
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.addon_file.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.addon_file = null
          })
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('slip_upload', this.addon_file, this.addon_file.name)
          formData.append('user_confirm_id', this.$store.state.userDetail.id)
          HTTP.post('debtors/updateslip/' + this.header_data.id, formData, config)
            .then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.addon_file = null
                this.get_data()
              }
            })
        }
      }
    },
    upload_addon_sub() {
      this.overlay = true
      this.image_addon = false
      if (this.$refs.image.validate()) {
        let extall = "png,PNG,jpeg,JPEG,jpg,JPG";
        let file = this.addon_file.name;
        let ext = file.split('.').pop().toLowerCase();
        if (parseInt(extall.indexOf(ext)) < 0) {
          Swal.fire({
            text: 'อัพโหลดได้เฉพาะไฟล์ รูป หรือ (.png, .PNG, .jpeg, .JPEG, .jpg, .JPG)',
            icon: 'error',
            showDenyButton: false,
            showCancelButton: false,
            confirmButtonText: `ตกลง`,
            denyButtonText: `ยกเลิก`,
          }).then(() => {
            this.imagePreviewURL = null
            this.addon_file = null
          })
        }
        else {
          let config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
          let formData = new FormData();
          formData.append('slip_image', this.addon_file, this.addon_file.name)
          formData.append('id', this.id)
          HTTP.post('debtors/approve/list/updateslip', formData, config)
            .then((res) => {
              if (res.data.success === true) {
                this.overlay = false
                this.addon_file = null
                this.image_addon_dialog = false
                this.get_data()
              }
            })
        }
      }
    },
    print_send_order(order_code) {
      window.open('https://www.pharmacare-plus.com/invoicepdfcreditpaywholesale/' + order_code, '_blank')
    },
    confirm_detail() {
      this.overlay = true
      this.image_modal = false
      HTTP.post('debtors/approve/' + this.header_data.id, {
        user_confirm_id: this.$store.state.userDetail.id
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.get_data()
        }
      })
    },
    in_correct() {
      this.overlay = true
      this.image_modal = false
      HTTP.post('debtors/cancel/' + this.header_data.id, {
        user_cancel_id: this.$store.state.userDetail.id
      }).then((res) => {
        if (res.data.success === true) {
          this.overlay = false
          this.get_data()
        }
      })
    }
  },
  mounted() {
    this.get_data()
  }
}
</script>

<style scoped>
.grid_mx {
  margin: 0;
}

.rounded_card {
  border-radius: 15px;
}

.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_sub_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

.grid_img {
  display: grid;
  grid-template-columns: 70% 30%;
}

.border_table {
  border: #e0e0e0 solid 1px
}

.mobile_btn {
  width: 50%;
}

.display_pc {
  display: block;
}

.display_mobile {
  display: none;
}

.mobile_grid {
  width: 25%
}

.grid_three {
  display: grid;
  grid-template-columns: 30% 70%;
}

.sub_grid_three {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_flex {
  display: flex;
}

.color_table_1>>>thead {
  background-color: #E2F5C7 !important;
}

.image_grid {
  display: grid;
  grid-template-columns: 15% 85%;
}

.font_size_grid {
  font-size: 18px !important;
}

.btn_size {
  width: 100%;
}

.cursor_img {
  cursor: pointer;
}

@media only screen and (max-width: 1180px) {
  .grid_three {
    display: grid;
    grid-template-columns: 25% 65%;
  }

  .font_size_grid {
    font-size: 14px !important;
  }

  .grid_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_grid {
    width: 32%
  }

  .image_grid {
    display: grid;
    grid-template-columns: 25% 75%;
  }

  .font_mobile {
    font-size: 14px !important;
  }
}

@media only screen and (max-width: 500px) {
  .grid_three {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .font_size_grid {
    font-size: 16px !important;
  }

  .sub_grid_three {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }

  .mobile_grid {
    width: 100%;
    margin-bottom: 15px;
  }

  .grid_mx {
    margin: auto;
  }

  .grid_sub_half {
    display: grid;
    grid-template-columns: 100%;
  }

  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 5px 0;
  }

  .grid_img {
    display: grid;
    grid-template-columns: 100%;
  }

  .mobile_btn {
    width: 100%;
  }

  .display_pc {
    display: none;
  }

  .display_mobile {
    display: block;
  }
}
</style>
